<template>
    <div class="breaking-news widget" v-if="news.length > 0">   
        <transition name="fade" mode="out-in">
            <a :href="currentNews[0].link" target="_blank">
                <table :style="{background:feedData.color}">
                    <tr>
                        <td class="widget-title">
                            <img :alt="feedData.name" :src="feedData.icon"/>
                            <span>{{ $t("home.widget.breakingnews") }}</span>
                        </td>
                        <td class="time">
                            {{currentNews[0].pubDate | formatHour}}
                        </td>
                        <td class="article-title">{{currentNews[0].title}} </td>
                    </tr>
                </table>
            </a>
        </transition>
        <div class="loading" v-if="loading">
            <b-spinner label="Loading..."></b-spinner>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BreakingNewsWidget",
        data() {
            return {              
                index: 0,
                currentNews: []
            }
        },
        props: {
            news: Array,
            feedData: Object,
            loading: Boolean
        },
        watch: {
            news: function () {
                this.currentNews = this.news.slice(0)
            }
        },
        mounted: function() {
            this.initNews()
        },
        methods: {
            async initNews() {                   
                setInterval(this.updateTicker, 2000);
            },
            updateTicker: function() {
                var removed = this.currentNews.pop();
                this.currentNews.unshift(removed);
            }
        }
    }
</script>

<style scoped>
.widget {
    position: relative;
}
.breaking-news.widget table {
    display: flex;
    color: #fff;
}
.breaking-news.widget .widget-title {
    padding: 8px 5px;
    position: relative;
    vertical-align: middle;
}
.breaking-news.widget .widget-title img {
    width: 45px;
}
.breaking-news.widget .widget-title span {
    display: none;
    font-weight: bold;
}
.breaking-news.widget .time {
    text-align: center;
    padding-left: 5px;
    padding-right: 5px;
    vertical-align: middle;
}
.breaking-news.widget .article-title {
    vertical-align: middle;
    color: #fff;
    padding: 8px 15px;
    vertical-align: middle;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}

#widget .loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  } 

@media (min-width: 768px){ 
    .breaking-news.widget table tr {
        display: flex;
        align-items: center;
    }
    .breaking-news.widget .widget-title {
        width: 200px;
        padding: 8px 15px;
        padding-left: 5px;
        display: flex;
        align-items: center;
    }
    .breaking-news.widget .widget-title img {
        margin-right: 5px;
    }
    .breaking-news.widget .widget-title span {
        display: inline-block;
    }
    .breaking-news.widget .time {
        padding-left: 15px;
        padding-right: 15px;
    }
}
</style>

